module.exports = __webpack_public_path__ + "static/img/video_logo.08dfbe3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desktop@1x/pic/video/video_logo.png
// module id = HH6h
// module chunks = 0